import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl } from "@angular/forms";
import { HttpClient, HttpEvent, HttpEventType } from '@angular/common/http';
import { Router, ActivatedRoute } from '@angular/router';
import { NgxSpinnerService } from "ngx-spinner";
import Swal from 'sweetalert2';
import * as moment from 'moment';
import 'moment-timezone';
import { LoginService } from '../../services/login.service';
import { DashboardService } from '../../services/dashboard.service';

@Component({
    selector: 'app-response',
    templateUrl: './response.component.html',
    styleUrls: ['./response.component.css'],
    encapsulation: ViewEncapsulation.None
})
export class ResponseComponent implements OnInit {

    public session_data: any = {};
    public err: any = {};
    public result: any = {};
    public form: any = {};
    public pending_search_form: any = {};
    public rejected_search_form: any = {};
    public deleted_search_form: any = {};

    projects: any = [];

    pending_keywords: any = [];
    deleted_keywords: any = [];
    total_deleted_keywords: any = 0;
    total_pending_keywords: any = 0;
    rejected_keywords: any = [];
    total_rejected_keywords: any = 0;

    deleted_start: any = 1;
    deleted_per_page: any = 10;

    pending_start: any = 1;
    pending_per_page: any = 10;

    rejected_start: any = 1;
    rejected_per_page: any = 10;

    constructor(private router: Router, private service: DashboardService, private spinner: NgxSpinnerService, private login: LoginService, private route: ActivatedRoute, public fb: FormBuilder) {
        this.session_data.id = login.get_session_data('ieye_session_id');
        this.session_data.email = login.get_session_data('ieye_session_email');
        this.service.setTitle('Keywords | 24ieye');
        this.form = this.fb.group({ id: [0], keyword: [''], project_id: [0], keyword_id: '' });
        this.pending_search_form = this.fb.group({ project_id: [0] });
        this.rejected_search_form = this.fb.group({ project_id: [0] });
        this.deleted_search_form = this.fb.group({ project_id: [0] });
    }
     
    ngOnInit(): void {
        this.get_pending_keywords();
        this.get_rejected_keywords();
        this.get_projects();
        this.get_deleted_keywords();
    }

    public async get_projects() {
        let input = {}
        this.result = await this.service.form_post_actions(input, '/projects/all');
        this.spinner.hide();
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.projects = this.result.data;
        }
    }

    public async get_deleted_keywords() {
        let input = { length: this.deleted_per_page, start: this.deleted_start, order_by: 'id', order_dir: 'desc', status: 4, project_id: this.deleted_search_form.value.project_id }
        this.result = await this.service.form_post_actions(input, '/keys');
        this.spinner.hide();
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.deleted_keywords = this.result.data;
            this.total_deleted_keywords = this.result.total;
        }
    }

    public async get_pending_keywords() {
        let input = { length: this.pending_per_page, start: this.pending_start, order_by: 'id', order_dir: 'desc', status: 1, project_id: this.pending_search_form.value.project_id }
        this.result = await this.service.form_post_actions(input, '/keys');
        this.spinner.hide();
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.pending_keywords = this.result.data;
            this.total_pending_keywords = this.result.total;
        }
    }

    public async get_rejected_keywords() {
        let input = { length: this.rejected_per_page, start: this.rejected_start, order_by: 'id', order_dir: 'desc', status: 3, project_id: this.rejected_search_form.value.project_id }
        this.result = await this.service.form_post_actions(input, '/keys');
        this.spinner.hide();
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.rejected_keywords = this.result.data;
            this.total_rejected_keywords = this.result.total;
        }
    }

    public async doAction() {
        this.result = await this.service.form_post_actions(this.form.value, '/keywords/approve');
        this.spinner.hide();
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            this.err = {}
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 });
            this.closeForm();
            this.get_pending_keywords();
            this.get_rejected_keywords();
            this.get_deleted_keywords();
        }
    }

    approve_keyword(data) {
        this.form.patchValue({ id: data.id, keyword: data.keyword, project_id: data.project_id });
    }

    public async keyword_status(id, status) {
        let input = { id: id, status: status }
        this.result = await this.service.form_post_actions(input, '/keywords/status-update');
        this.spinner.hide();
        if (this.result.status == false) {
            if (this.result.code == 202) {
                this.err = {};
                Swal.fire('Alert!', this.result.message, 'error');
            } else {
                this.err = this.result.errors;
            }
        } else {
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 });
            //find current page
            if (status == 1) {
                let total = (parseInt(this.total_rejected_keywords) - 1) / parseInt(this.rejected_per_page);
                this.rejected_start = total ? Math.ceil(total) : 1;
                this.pending_start = 1;
            }
            if (status == 3) {
                let total = (parseInt(this.total_pending_keywords) - 1) / parseInt(this.pending_per_page);
                this.pending_start = total ? Math.ceil(total) : 1;
                this.rejected_start = 1;
            }

            this.get_pending_keywords();
            this.get_rejected_keywords();
            this.get_deleted_keywords();
        }
    }

    closeForm() {
        this.form.patchValue({ id: 0, keyword: '', project_id: 0 });
    }

    pendingPageChanged(page) {
        let total_pages = this.total_pending_keywords / this.pending_per_page;
        this.pending_start = page;
        this.get_pending_keywords();
    }

    rejectedPageChanged(page) {
        let total_pages = this.total_rejected_keywords / this.rejected_per_page;
        this.rejected_start = page;
        this.get_rejected_keywords();
    }

    deletedPageChanged(page) {
        let total_pages = this.total_deleted_keywords / this.deleted_per_page;
        this.deleted_start = page;
        this.get_deleted_keywords();
    }

    pendingSearch() {
        this.pending_start = 1;
        this.get_pending_keywords();
    }
    
    rejectedSearch() {
        this.rejected_start = 1;
        this.get_rejected_keywords();
    }

    deletedSearch() {
        this.deleted_start = 1;
        this.get_deleted_keywords();
    }
    
    public keyword_delete(id, type) {
        Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!'
        }).then((action) => {
            if (action.isConfirmed) {
                this.delete_action(id);                
            }
        });
    }
    
    public async delete_action(id) {
        this.spinner.show();
        let input = { id: id }
        this.result = await this.service.form_post_actions(input, '/keys/delete');

        if (this.result.status == true) {
            this.spinner.hide();
            Swal.fire({ icon: 'success', title: this.result.message, showConfirmButton: false, timer: 1500 })
            this.deletedSearch();
        } else {
            this.spinner.hide();
            Swal.fire('Alert!', this.result.message, 'error');
        }
    }

}
